import * as React from "react";
const Rocket = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 95 95", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { clipPath: "url(#prefix__a)" },
        React.createElement("mask", { id: "prefix__b", width: 95, height: 95, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
                maskType: "luminance",
            } },
            React.createElement("path", { fill: "#fff", d: "M95 0H0v95h95z" })),
        React.createElement("g", { mask: "url(#prefix__b)" },
            React.createElement("path", { fill: "#CFCFCF", d: "M24.3 86.098v-23.2l-15.4 23.2z" }),
            React.createElement("path", { fill: "#3F3F3F", d: "M59.1 16.6H35.9L47.5 1.2z" }),
            React.createElement("path", { fill: "#ED0000", d: "M70.7 86.098h15.4l-15.4-23.2z" }),
            React.createElement("path", { fill: "#3F3F3F", d: "M56.2 86.1H39.8l-7.7 7.7h31.8z" }),
            React.createElement("path", { fill: "#CFCFCF", d: "M59.1 16.6H47.5v69.5h23.2V55.3c0-16.2-5.3-30.3-11.6-38.7" }),
            React.createElement("path", { fill: "#ED0000", d: "M35.9 16.6c-6.3 8.3-11.6 22.5-11.6 38.6v30.9h23.2V16.6z" }),
            React.createElement("path", { fill: "#fff", d: "M47.5 47.5a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "prefix__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h95v95H0z" })))));
export default Rocket;
//# sourceMappingURL=Rocket.js.map